import { useParams } from "react-router-dom";
import Breadcrumb from "@/components/feature/Breadcrumb";
import NewsBrowser from "@/components/feature/NewsBrowser";
import PageEmpty from "@/components/feature/PageEmpty";
import { getCategory, getNewsByCategory } from "@/utils/news";
import { useDocumentTitle } from "@/hooks/useDocumentTitle";

export default function CategoryPage() {
  const { categoryName = "" } = useParams();
  const category = getCategory(categoryName);

  useDocumentTitle(
    category
      ? `${category.name}新闻 - 911爆料`
      : "分类不存在 - 911爆料"
  );

  if (!category) {
    return (
      <PageEmpty
        icon="ri-folder-unknow-line"
        title="未找到该分类"
        description="您访问的分类可能已被调整或不存在，请从首页重新选择新闻分类。"
        actionLabel="返回首页"
        actionTo="/"
      />
    );
  }

  const items = getNewsByCategory(category.slug);

  return (
    <div className="mx-auto w-full max-w-shell animate-fade-up px-4 py-8 md:px-6 md:py-10">
      <Breadcrumb
        items={[
          { label: "首页", to: "/" },
          { label: `${category.name}新闻` },
        ]}
      />

      <header className="mt-5 border-b border-background-200 pb-6">
        <div className="flex items-center gap-2">
          <span className="h-6 w-1.5 rounded-full bg-primary-500" />
          <h1 className="font-heading text-2xl font-black text-foreground-950 md:text-3xl">
            {category.name}新闻
          </h1>
        </div>
        <p className="mt-3 max-w-2xl text-sm leading-relaxed text-foreground-600">
          {category.description}
        </p>
      </header>

      <div className="mt-8">
        <NewsBrowser
          items={items}
          emptyText="当前分类暂无新闻，尝试调整筛选条件。"
          initialExclusiveOnly={category.slug === "exclusive"}
        />
      </div>
    </div>
  );
}